import { SHOW_MODAL, CLEAR_MODAL } from 'actions/Types';

/**
 * In cases where you need to show a modal, use this state (no longer want to use one-off reducers like 'creatingEvent', etc)
 */
export default (state = null, action) => {
  if (action.type === SHOW_MODAL) {
    return action.payload;
  }

  if (action.type === CLEAR_MODAL) {
    if (state && action.payload === state.type) return null;
  }

  return state;
};
